export default "__VITE_ASSET__CPxAPduY__"